import { useContext, createContext } from 'react';
import { AuthorityCitizenContext, SocialProviderCitizenContext, CommonCitizenContext, SocialProviderUnitDto } from '../../api-service/clients';

export interface AuthorityCitizenContextLegacy extends AuthorityCitizenContext {
  isLoading?: boolean;
}

export type ServiceProviderContext = SocialProviderCitizenContext & {
  currentServiceProvider: SocialProviderUnitDto | undefined;
  setCurrentServiceProvider: (unitId: string | undefined) => void;
};

export const CommonCitizenCtx = createContext<CommonCitizenContext>({} as CommonCitizenContext);
export const AuthorityCitizenCtx = createContext<AuthorityCitizenContextLegacy>({} as AuthorityCitizenContextLegacy);
export const ServiceProviderCitizenCtx = createContext<ServiceProviderContext>({} as ServiceProviderContext);

export function useCommonCitizenContext() {
  return useContext(CommonCitizenCtx);
}

export function useCitizenContext() {
  return useContext(AuthorityCitizenCtx);
}

export function useServiceProviderCitizenContext() {
  return useContext(ServiceProviderCitizenCtx);
}


